<template>
  <div class="app-container">
    <!-- 导航栏 -->
    <header class="header">
      <div class="container">
        <nav class="nav-container">
          <div class="logo">
            <!-- <span class="logo-highlight">YUANYUAN</span>INDUSTRY -->
            <img src="../assets/logo.png" alt="" style="width:clamp(7rem, 18vw, 12rem);">
          </div>
          
          <!-- 桌面导航 -->
          <div class="desktop-nav">
            <a href="#home" class="nav-link">首页</a>
            <a href="#properties" class="nav-link">物业类型</a>
            <a href="#projects" class="nav-link">精选项目</a>
            <a href="#services" class="nav-link">服务优势</a>
            <a href="#contact" class="nav-link">联系我们</a>
            <button class="primary-btn nav-btn">预约考察</button>
          </div>
          
          <!-- 移动端菜单按钮 -->
          <button class="menu-btn" @click="isMenuOpen = !isMenuOpen" aria-label="菜单">
            <svg class="menu-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
        </nav>
      </div>
      
      <!-- 移动端导航菜单 -->
      <div class="mobile-nav" v-if="isMenuOpen">
        <div class="container">
          <a href="#home" class="mobile-nav-link" @click="isMenuOpen = false">首页</a>
          <a href="#properties" class="mobile-nav-link" @click="isMenuOpen = false">物业类型</a>
          <a href="#projects" class="mobile-nav-link" @click="isMenuOpen = false">精选项目</a>
          <a href="#services" class="mobile-nav-link" @click="isMenuOpen = false">服务优势</a>
          <a href="#contact" class="mobile-nav-link" @click="isMenuOpen = false">联系我们</a>
          <button class="primary-btn mobile-nav-btn">预约考察</button>
        </div>
      </div>
    </header>

    <main>
      <!-- 英雄区域 -->
      <section id="home" class="hero-section">
        <div class="hero-bg"></div>
        <div class="container hero-content">
          <div class="hero-text">
            <h1 class="hero-title">专业工业地产<br>解决方案提供商</h1>
            <p class="hero-desc">
              我们专注于工业厂房、物流仓储、产业园区的开发与运营，为企业提供定制化的空间解决方案。
            </p>
            <div class="hero-btns">
              <button class="primary-btn hero-primary-btn">探索物业</button>
              <button class="secondary-btn hero-secondary-btn">了解服务</button>
            </div>
          </div>
        </div>
        <div class="hero-gradient"></div>
      </section>

      <!-- 核心数据 -->
      <section class="stats-section">
        <div class="container">
          <div class="stats-grid">
            <div class="stat-item">
              <div class="stat-value">50+</div>
              <div class="stat-label">产业园区</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">120万+</div>
              <div class="stat-label">平方米物业</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">300+</div>
              <div class="stat-label">合作企业</div>
            </div>
            <div class="stat-item">
              <div class="stat-value">15年</div>
              <div class="stat-label">专业经验</div>
            </div>
          </div>
        </div>
      </section>

      <!-- 物业类型 -->
      <section id="properties" class="properties-section">
        <div class="container">
          <div class="section-header">
            <h2 class="section-title">多元化物业类型</h2>
            <p class="section-desc">
              我们提供多种类型的工业地产选择，满足不同行业、不同规模企业的多样化需求
            </p>
          </div>
          
          <div class="properties-grid">
            <!-- 物业类型1 -->
            <div class="property-card">
              <div class="property-img-container">
                <img src="../assets/home/factory.png" alt="标准厂房" class="property-img">
              </div>
              <div class="property-info">
                <h3 class="property-title">标准厂房</h3>
                <p class="property-desc">
                  标准化设计的工业厂房，配备完善的基础设施，适合各类中小型制造企业快速入驻。
                </p>
                <ul class="property-features">
                  <li class="property-feature">
                    <svg class="check-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    层高6-8米，承重500-1000kg/㎡
                  </li>
                  <li class="property-feature">
                    <svg class="check-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    配备10-15吨行车梁
                  </li>
                </ul>
                <a href="#" class="more-link">
                  了解更多 
                  <svg class="arrow-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                  </svg>
                </a>
              </div>
            </div>
            
            <!-- 物业类型2 -->
            <div class="property-card">
              <div class="property-img-container">
                <img src="../assets/home/warehouse.png" alt="物流仓储" class="property-img">
              </div>
              <div class="property-info">
                <h3 class="property-title">物流仓储</h3>
                <p class="property-desc">
                  现代化仓储设施，地理位置优越，交通便利，适合物流配送、区域分拨及货物存储。
                </p>
                <ul class="property-features">
                  <li class="property-feature">
                    <svg class="check-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    高站台设计，装卸便捷
                  </li>
                  <li class="property-feature">
                    <svg class="check-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    配备立体仓储系统
                  </li>
                </ul>
                <a href="#" class="more-link">
                  了解更多 
                  <svg class="arrow-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                  </svg>
                </a>
              </div>
            </div>
            
            <!-- 物业类型3 -->
            <div class="property-card">
              <div class="property-img-container">
                <img src="../assets/home/industrial.png" alt="产业园区" class="property-img">
              </div>
              <div class="property-info">
                <h3 class="property-title">产业园区</h3>
                <p class="property-desc">
                  综合性产业园区，集生产、研发、办公于一体，提供完善的配套设施和产业服务。
                </p>
                <ul class="property-features">
                  <li class="property-feature">
                    <svg class="check-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    产业集群效应，上下游联动
                  </li>
                  <li class="property-feature">
                    <svg class="check-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                    完善的生活配套设施
                  </li>
                </ul>
                <a href="#" class="more-link">
                  了解更多 
                  <svg class="arrow-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 精选项目 -->
      <section id="projects" class="projects-section">
        <div class="container">
          <div class="projects-header">
            <div>
              <h2 class="section-title">精选项目</h2>
              <p class="section-desc">
                我们精心打造的标杆项目，为企业提供高品质的生产经营空间
              </p>
            </div>
            <a href="#" class="more-link projects-more-link">
              查看全部项目 
              <svg class="arrow-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
              </svg>
            </a>
          </div>
          
          <div class="projects-grid">
            <!-- 项目1 -->
            <div class="project-card">
              <div class="project-img-container">
                <img src="../assets/home/Intelligent.png" alt="东部智能制造产业园" class="project-img">
                <div class="project-tag new-tag">新建项目</div>
              </div>
              <h3 class="project-title">东部智能制造产业园</h3>
              <div class="project-location">
                <svg class="location-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
                东部经济开发区
              </div>
              <p class="project-desc">
                总占地面积500亩，专注于智能制造、电子信息等高新技术产业，打造集研发、生产、展示于一体的现代化产业园区。
              </p>
              <div class="project-details">
                <div class="project-detail-item">
                  <div class="detail-label">总建筑面积</div>
                  <div class="detail-value">35万平方米</div>
                </div>
                <div class="project-detail-item">
                  <div class="detail-label">主导产业</div>
                  <div class="detail-value">智能制造、电子信息</div>
                </div>
              </div>
            </div>
            
            <!-- 项目2 -->
            <div class="project-card">
              <div class="project-img-container">
                <img src="../assets/home/modern.png" alt="现代综合物流园" class="project-img">
                <div class="project-tag hot-tag">热销中</div>
              </div>
              <h3 class="project-title">现代综合物流园</h3>
              <div class="project-location">
                <svg class="location-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
                港口经济区
              </div>
              <p class="project-desc">
                紧邻国际深水港，总投资20亿元，建设现代化智能仓储中心、冷链物流区和区域分拨中心，打造区域物流枢纽。
              </p>
              <div class="project-details">
                <div class="project-detail-item">
                  <div class="detail-label">总建筑面积</div>
                  <div class="detail-value">42万平方米</div>
                </div>
                <div class="project-detail-item">
                  <div class="detail-label">功能定位</div>
                  <div class="detail-value">仓储、分拨、冷链</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 服务优势 -->
      <section id="services" class="services-section">
        <div class="container">
          <div class="section-header text-center">
            <h2 class="section-title light-title">我们的服务优势</h2>
            <p class="section-desc light-desc">
              不止于提供空间，更致力于为企业创造价值，全程护航企业发展
            </p>
          </div>
          
          <div class="services-grid">
            <!-- 优势1 -->
            <div class="service-card">
              <div class="service-icon-container">
                <svg class="service-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
                </svg>
              </div>
              <h3 class="service-title">选址咨询</h3>
              <p class="service-desc">
                基于企业需求和行业特点，提供专业的选址建议，分析区域政策、交通、产业链等因素，助力企业做出最优决策。
              </p>
            </div>
            
            <!-- 优势2 -->
            <div class="service-card">
              <div class="service-icon-container">
                <svg class="service-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
                </svg>
              </div>
              <h3 class="service-title">定制化建设</h3>
              <p class="service-desc">
                根据企业生产工艺需求，提供定制化厂房建设服务，从规划设计到施工验收，全程专业团队跟进。
              </p>
            </div>
            
            <!-- 优势3 -->
            <div class="service-card">
              <div class="service-icon-container">
                <svg class="service-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                </svg>
              </div>
              <h3 class="service-title">政策对接</h3>
              <p class="service-desc">
                熟悉各地产业政策，协助企业对接政府部门，争取税收优惠、人才引进、资金扶持等政策支持。
              </p>
            </div>
            
            <!-- 优势4 -->
            <div class="service-card">
              <div class="service-icon-container">
                <svg class="service-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
                </svg>
              </div>
              <h3 class="service-title">运营服务</h3>
              <p class="service-desc">
                提供全方位的园区运营服务，包括物业管理、安全保卫、绿化保洁、会务接待等，让企业专注核心业务。
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- 联系我们 -->
      <section id="contact" class="contact-section">
        <div class="container">
          <div class="contact-grid">
            <div class="contact-info">
              <h2 class="section-title">联系我们</h2>
              <p class="section-desc">
                无论您是想了解更多项目信息，还是有定制化需求，我们的专业团队都将为您提供一对一服务
              </p>
              
              <div class="contact-details">
                <div class="contact-detail">
                  <div class="contact-icon-container">
                    <svg class="contact-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    </svg>
                  </div>
                  <div class="contact-text">
                    <h3 class="contact-label">总部地址</h3>
                    <p class="contact-value">惠州市博罗县园洲镇福园路268号</p>
                  </div>
                </div>
                
                <div class="contact-detail">
                  <div class="contact-icon-container">
                    <svg class="contact-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                    </svg>
                  </div>
                  <div class="contact-text">
                    <h3 class="contact-label">联系电话</h3>
                    <p class="contact-value">13537347009</p>
                  </div>
                </div>
                
                <div class="contact-detail">
                  <div class="contact-icon-container">
                    <svg class="contact-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                    </svg>
                    
                  </div>
                  <div class="contact-text">
                    <h3 class="contact-label">电子邮箱</h3>
                    <p class="contact-value">445840129@qq.com</p>
                  </div>
                </div>
              </div>
              
              <div class="social-links">
                <a  class="social-link" aria-label="微信">
                  <svg class="social-icon" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"></path>
                  </svg>
                </a>
                <a  class="social-link" aria-label="微博">
                  <svg class="social-icon" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"></path>
                  </svg>
                </a>
                <a  class="social-link" aria-label="领英">
                  <svg class="social-icon" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"></path>
                  </svg>
                </a>
              </div>
            </div>
            
            <div class="contact-form-container">
              <div class="contact-form-card">
                <h3 class="form-title">预约考察</h3>
                <form class="contact-form">
                  <div class="form-row">
                    <div class="form-group">
                      <label for="name" class="form-label">姓名</label>
                      <input type="text" id="name" class="form-input" placeholder="请输入您的姓名">
                    </div>
                    <div class="form-group">
                      <label for="phone" class="form-label">电话</label>
                      <input type="tel" id="phone" class="form-input" placeholder="请输入您的联系电话">
                    </div>
                  </div>
                  
                  <div class="form-group">
                    <label for="company" class="form-label">公司名称</label>
                    <input type="text" id="company" class="form-input" placeholder="请输入公司名称">
                  </div>
                  
                  <div class="form-group">
                    <label for="interest" class="form-label">感兴趣的物业类型</label>
                    <select id="interest" class="form-select">
                      <option value="">请选择物业类型</option>
                      <option value="factory">标准厂房</option>
                      <option value="logistics">物流仓储</option>
                      <option value="park">产业园区</option>
                      <option value="other">其他</option>
                    </select>
                  </div>
                  
                  <div class="form-group">
                    <label for="message" class="form-label">留言</label>
                    <textarea id="message" rows="4" class="form-textarea" placeholder="请输入您的需求或疑问"></textarea>
                  </div>
                  
                  <button type="submit" class="primary-btn form-submit">提交预约</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-grid">
          <div class="footer-col">
            <div class="footer-logo">
              <span class="logo-highlight">YUANYUAN</span>INDUSTRY
            </div>
            <p class="footer-desc">
              专业的工业地产解决方案提供商，致力于为企业打造优质的生产经营空间。
            </p>
            <div class="footer-social">
              <a  class="social-link" aria-label="微信">
                <svg class="social-icon" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"></path>
                </svg>
              </a>
              <a  class="social-link" aria-label="微博">
                <svg class="social-icon" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"></path>
                </svg>
              </a>
              <a  class="social-link" aria-label="领英">
                <svg class="social-icon" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"></path>
                </svg>
              </a>
            </div>
          </div>
          
          <div class="footer-col">
            <h3 class="footer-col-title">快速链接</h3>
            <ul class="footer-links">
              <li><a href="#home" class="footer-link">首页</a></li>
              <li><a href="#properties" class="footer-link">物业类型</a></li>
              <li><a href="#projects" class="footer-link">精选项目</a></li>
              <li><a href="#services" class="footer-link">服务优势</a></li>
              <li><a href="#contact" class="footer-link">联系我们</a></li>
            </ul>
          </div>
          
          <div class="footer-col">
            <h3 class="footer-col-title">物业类型</h3>
            <ul class="footer-links">
              <li><a  class="footer-link">标准厂房</a></li>
              <li><a  class="footer-link">物流仓储</a></li>
              <li><a  class="footer-link">产业园区</a></li>
              <li><a  class="footer-link">定制厂房</a></li>
              <li><a  class="footer-link">研发中心</a></li>
            </ul>
          </div>
          
          <div class="footer-col">
            <h3 class="footer-col-title">联系信息</h3>
            <ul class="footer-contact">
              <li class="footer-contact-item">
                <svg class="contact-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
                <span>惠州市博罗县园洲镇福园路268号</span>
              </li>
              <li class="footer-contact-item">
                <svg class="contact-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                </svg>
                
                <span>13537347009</span>
              </li>
              <li class="footer-contact-item">
                <svg class="contact-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                </svg>
                <span>445840129@qq.com</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div class="footer-bottom">
          <div class="copyright">
            Copyright &copy; 2025 惠州市圆元产业咨询有限公司 保留所有权利. <a href="https://beian.miit.gov.cn/#/Integrated/index" style="color: #fff;">粤ICP备2025493357号</a>
          </div>
          <div class="footer-bottom-links">
            <a  class="footer-bottom-link">隐私政策</a>
            <a  class="footer-bottom-link">使用条款</a>
            <a  class="footer-bottom-link">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMenuOpen: false
    };
  },
  mounted() {
    // 导航栏滚动效果
    window.addEventListener('scroll', () => {
      const header = document.querySelector('.header');
      if (window.scrollY > 50) {
        header.classList.add('header-scrolled');
      } else {
        header.classList.remove('header-scrolled');
      }
    });

    // 平滑滚动
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();
        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - 80,
            behavior: 'smooth'
          });
        }
      });
    });
  }
};
</script>

<style scoped>

html {
  scroll-behavior: smooth;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: var(--secondary-color);
  background-color: var(--light-color);
  line-height: 1.6;
}

.app-container {
  min-height: 100vh;
  overflow-x: hidden;
}

.container {
  width: 100%;
  padding-right: clamp(1rem, 3vw, 2rem);
  padding-left: clamp(1rem, 3vw, 2rem);
  margin-right: auto;
  margin-left: auto;
  max-width: 1400px;
}

/* 字体样式 */
.section-title {
  font-size: clamp(1.8rem, 3vw, 2.5rem);
  font-weight: 700;
  color: var(--secondary-color);
  margin-bottom: 1rem;
  line-height: 1.2;
}

.light-title {
  color: white;
}

.section-desc {
  font-size: clamp(1rem, 1.5vw, 1.1rem);
  color: var(--gray-dark);
  max-width: 2xl;
  margin: 0 auto;
}

.light-desc {
  color: var(--gray);
}

/* 按钮样式 */
.primary-btn {
  display: inline-block;
  background-color: var(--primary-color);
  color: white;
  font-weight: 500;
  padding: 0.75rem 1.5rem;
  border-radius: 0.375rem;
  transition: var(--transition);
  border: none;
  cursor: pointer;
  font-size: clamp(1rem, 1.2vw, 1.1rem);
}

.primary-btn:hover {
  background-color: var(--primary-dark);
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.secondary-btn {
  display: inline-block;
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(4px);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  font-weight: 500;
  padding: 0.75rem 1.5rem;
  border-radius: 0.375rem;
  transition: var(--transition);
  cursor: pointer;
  font-size: clamp(1rem, 1.2vw, 1.1rem);
}

.secondary-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

/* 导航栏样式 */
.header {
  position: sticky;
  top: 0;
  z-index: 50;
  background-color: var(--primary-color);
  transition: var(--transition);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

.header-scrolled {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
}

.nav-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
}

.logo {
  font-size: clamp(1.25rem, 2vw, 1.5rem);
  font-weight: 700;
  color: var(--secondary-color);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer
}

.logo-highlight {
  color: var(--primary-color);
}

.desktop-nav {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.nav-link {
  color: var(--light-color);
  font-weight: 500;
  padding: 0.55rem 1.5rem;
  border-radius: 0.375rem;
  text-decoration: none;
  transition: var(--transition);
}

.nav-link:hover {
  color: var(--primary-color);
  background-color: white;
}

.nav-btn {
  padding: 0.5rem 1rem;
}

.menu-btn {
  display: none;
  background: none;
  border: none;
  color: var(--secondary-color);
  cursor: pointer;
}

.menu-icon {
  width: 24px;
  height: 24px;
}

.mobile-nav {
  display: none;
  background-color: white;
  border-top: 1px solid var(--gray-light);
  animation: fadeIn 0.3s ease-out forwards;
}

.mobile-nav .container {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.mobile-nav-link {
  color: var(--gray-dark);
  text-decoration: none;
  padding: 0.5rem 0;
  transition: var(--transition);
}

.mobile-nav-link:hover {
  color: var(--primary-color);
}

.mobile-nav-btn {
  width: 100%;
  margin-top: 0.5rem;
}

/* 英雄区域样式 */
.hero-section {
  position: relative;
  min-height: 80vh;
  display: flex;
  align-items: center;
  background-color: var(--secondary-color);
}

.hero-bg {
  position: absolute;
  inset: 0;
  opacity: 0.3;
  background-image: url('https://picsum.photos/id/1067/1920/1080');
  background-size: cover;
  background-position: center;
}

.hero-content {
  position: relative;
  z-index: 10;
  width: 100%;
  padding-top: 4rem;
  padding-bottom: 4rem;
}

.hero-text {
  max-width: 2xl;
}

.hero-title {
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 700;
  color: white;
  line-height: 1.1;
  margin-bottom: 1.5rem;
}

.hero-desc {
  font-size: clamp(1rem, 2vw, 1.25rem);
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 2rem;
}

.hero-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.hero-primary-btn {
  padding: 0.875rem 2rem;
}

.hero-secondary-btn {
  padding: 0.875rem 2rem;
}

.hero-gradient {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4rem;
  background: linear-gradient(to top, var(--light-color), transparent);
}

/* 核心数据样式 */
.stats-section {
  padding-top: 3rem;
  padding-bottom: 3rem;
  background-color: white;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}

@media (min-width: 768px) {
  .stats-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.stat-item {
  padding: 1.5rem;
  text-align: center;
}

.stat-value {
  font-size: clamp(1.8rem, 4vw, 2.5rem);
  font-weight: 700;
  color: var(--primary-color);
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: clamp(0.9rem, 1.5vw, 1rem);
  color: var(--gray-dark);
}

/* 物业类型样式 */
.properties-section {
  padding-top: 6rem;
  padding-bottom: 6rem;
  background-color: var(--gray-light);
}

.section-header {
  text-align: center;
 想说: 4rem;
}

.properties-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  margin-top: 4rem;
}

@media (min-width: 768px) {
  .properties-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .properties-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.property-card {
  background-color: white;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  transition: var(--transition);
}

.property-card:hover {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  transform: translateY(-5px);
}

.property-img-container {
  height: 220px;
  overflow: hidden;
}

.property-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.property-card:hover .property-img {
  transform: scale(1.1);
}

.property-info {
  padding: 1.5rem;
}

.property-title {
  font-size: clamp(1.2rem, 2vw, 1.5rem);
  font-weight: 700;
  color: var(--secondary-color);
  margin-bottom: 0.75rem;
}

.property-desc {
  color: var(--gray-dark);
  margin-bottom: 1rem;
}

.property-features {
  list-style: none;
  margin-bottom: 1.5rem;
}

.property-feature {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  color: var(--gray-dark);
  margin-bottom: 0.5rem;
}

.check-icon {
  width: 16px;
  height: 16px;
  color: var(--primary-color);
  margin-right: 0.5rem;
}

.more-link {
  display: inline-flex;
  align-items: center;
  color: var(--primary-color);
  font-weight: 500;
  text-decoration: none;
  transition: var(--transition);
}

.more-link:hover {
  color: var(--primary-dark);
}

.arrow-icon {
  width: 16px;
  height: 16px;
  margin-left: 0.25rem;
}

/* 精选项目样式 */
.projects-section {
  padding-top: 6rem;
  padding-bottom: 6rem;
  background-color: white;
}

.projects-header {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 3rem;
}

@media (min-width: 768px) {
  .projects-header {
    flex-direction: row;
    align-items: flex-end;
  }
}

.projects-more-link {
  margin-top: 1rem;
}

@media (min-width: 768px) {
  .projects-more-link {
    margin-top: 0;
  }
}

.projects-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2.5rem;
}

@media (min-width: 768px) {
  .projects-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.project-card {
  transition: var(--transition);
}

.project-card:hover .project-title {
  color: var(--primary-color);
}

.project-img-container {
  position: relative;
  border-radius: 0.5rem;
  overflow: hidden;
  margin-bottom: 1rem;
}

.project-img {
  width: 100%;
  height: clamp(200px, 40vw, 400px);
  object-fit: cover;
  transition: transform 0.7s ease;
}

.project-card:hover .project-img {
  transform: scale(1.05);
}

.project-tag {
  position: absolute;
  top: 1rem;
  left: 1rem;
  padding: 0.25rem 0.75rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 500;
  color: white;
}

.new-tag {
  background-color: var(--primary-color);
}

.hot-tag {
  background-color: var(--success-color);
}

.project-title {
  font-size: clamp(1.2rem, 2vw, 1.5rem);
  font-weight: 700;
  color: var(--secondary-color);
  margin-bottom: 0.5rem;
  transition: var(--transition);
}

.project-location {
  display: flex;
  align-items: center;
  color: var(--gray);
  font-size: 0.875rem;
  margin-bottom: 1rem;
}

.location-icon {
  width: 16px;
  height: 16px;
  margin-right: 0.25rem;
}

.project-desc {
  color: var(--gray-dark);
  margin-bottom: 1.5rem;
}

.project-details {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  font-size: 0.875rem;
}

.project-detail-item {
  background-color: var(--gray-light);
  padding: 0.75rem;
  border-radius: 0.375rem;
}

.detail-label {
  color: var(--gray);
  margin-bottom: 0.25rem;
}

.detail-value {
  font-weight: 500;
}

/* 服务优势样式 */
.services-section {
  padding-top: 6rem;
  padding-bottom: 6rem;
  background-color: var(--secondary-color);
  color: white;
}

.services-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  margin-top: 4rem;
}

@media (min-width: 768px) {
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .services-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.service-card {
  background-color: rgba(30, 41, 59, 0.5);
  padding: 1.5rem;
  border-radius: 0.5rem;
  transition: var(--transition);
}

.service-card:hover {
  background-color: rgba(30, 41, 59, 0.8);
  transform: translateY(-5px);
}

.service-icon-container {
  width: 3rem;
  height: 3rem;
  background-color: var(--primary-color);
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem;
}

.service-icon {
  width: 1.5rem;
  height: 1.5rem;
  color: white;
}

.service-title {
  font-size: clamp(1.1rem, 2vw, 1.3rem);
  font-weight: 700;
  margin-bottom: 0.75rem;
}

.service-desc {
  color: var(--gray);
  font-size: 0.875rem;
}

/* 联系我们样式 */
.contact-section {
  padding-top: 6rem;
  padding-bottom: 6rem;
  background-color: var(--gray-light);
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
}

@media (min-width: 1024px) {
  .contact-grid {
    grid-template-columns: 1fr 1fr;
  }
}

.contact-info .section-desc {
  margin: 0 0 2.5rem 0;
}

.contact-details {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-bottom: 2.5rem;
}

.contact-detail {
  display: flex;
  align-items: flex-start;
}

.contact-icon-container {
  width: 2.5rem;
  height: 2.5rem;
  background-color: var(--primary-light);
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  flex-shrink: 0;
  margin-top: 0.25rem;
}

.contact-icon {
  width: 1.25rem;
  height: 1.25rem;
  color: var(--primary-color);
}

.contact-label {
  font-weight: 700;
  color: var(--secondary-color);
  margin-bottom: 0.25rem;
}

.contact-value {
  color: var(--gray-dark);
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-link {
  width: 2.5rem;
  height: 2.5rem;
  background-color: var(--primary-color);
  color: white;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition);
}

.social-link:hover {
  background-color: var(--primary-dark);
  transform: translateY(-3px);
}

.social-icon {
  width: 1.25rem;
  height: 1.25rem;
}

.contact-form-card {
  background-color: white;
  padding: 2rem;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.form-title {
  font-size: clamp(1.3rem, 2vw, 1.6rem);
  font-weight: 700;
  color: var(--secondary-color);
  margin-bottom: 1.5rem;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
}

@media (min-width: 768px) {
  .form-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--gray-dark);
}

.form-input,
.form-select,
.form-textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--gray);
  border-radius: 0.375rem;
  font-size: 1rem;
  transition: var(--transition);
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.form-textarea {
  resize: vertical;
}

.form-submit {
  width: 100%;
  padding: 0.875rem;
}

/* 页脚样式 */
.footer {
  background-color: var(--secondary-color);
  color: white;
  padding-top: 4rem;
  padding-bottom: 2rem;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 3rem;
  margin-bottom: 3rem;
}

@media (min-width: 768px) {
  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .footer-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.footer-logo {
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  margin-bottom: 1.5rem;
}

.footer-desc {
  color: var(--gray);
  margin-bottom: 1.5rem;
  font-size: 0.875rem;
}

.footer-col-title {
  font-size: 1.125rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
}

.footer-links {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.footer-link {
  color: var(--gray);
  text-decoration: none;
  transition: var(--transition);
  font-size: 0.875rem;
}

.footer-link:hover {
  color: white;
  padding-left: 0.5rem;
}

.footer-contact {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.footer-contact-item {
  display: flex;
  align-items: flex-start;
  color: var(--gray);
  font-size: 0.875rem;
}

.footer-contact-item .contact-icon {
  color: var(--gray);
  margin-right: 0.75rem;
  margin-top: 0.25rem;
}

.footer-social {
  display: flex;
  gap: 1rem;
}

.footer-bottom {
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

@media (min-width: 768px) {
  .footer-bottom {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}

.copyright {
  color: var(--gray);
  font-size: 0.875rem;
}

.footer-bottom-links {
  display: flex;
  gap: 2rem;
}

.footer-bottom-link {
  color: var(--gray);
  text-decoration: none;
  font-size: 0.875rem;
  transition: var(--transition);
}

.footer-bottom-link:hover {
  color: white;
}

/* 动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式调整 */
@media (max-width: 767px) {
  .desktop-nav {
    display: none;
  }
  
  .menu-btn {
    display: block;
  }
  
  .mobile-nav {
    display: block;
  }
}
</style>
